import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { VehicleCategoryListItem } from '../models/common.model';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleCategoryService extends BaseHttpService {
  private _cacheService = inject(CacheService);

  getAllVehicleCategories(): Observable<VehicleCategoryListItem[]> {
    return this._cacheService.cacheObservable(
      '/api/vehiclecategory',
      this.httpClient.get<VehicleCategoryListItem[]>(`${this.baseApiUrl}/api/vehiclecategory`)
    );
  }

  getVehicleCategoryByUid(uid: string): Observable<VehicleCategoryListItem> {
    return this.httpClient.get<VehicleCategoryListItem>(`${this.baseApiUrl}/api/vehiclecategory/${uid}`);
  }

  getVehicleCategoryByCode(code: string): Observable<VehicleCategoryListItem> {
    return this.httpClient.get<VehicleCategoryListItem>(`${this.baseApiUrl}/api/vehiclecategory/getByCode/${code}`);
  }
}
